<template>
    <div class="library-visible-to-filter" data-testid="library-visible-to-filter">
        <collapsible-widget>
            <template #name>Visible To</template>

            <RadioGroup :model-value="selectedFilters">
                <Radio :label="null" @click.stop.prevent="setSelectedFilters(null)">Me</Radio>
                <Radio
                    v-for="{ label, value } in options"
                    :key="value"
                    :label="value"
                    @click.stop.prevent="setSelectedFilters(value)"
                >
                    {{ label }}
                </Radio>
            </RadioGroup>
        </collapsible-widget>
    </div>
</template>

<script>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";
import { RolesGetter } from "@/store/modules/roles";

export default {
    name: "LibraryVisibleToFilter",
    components: {
        CollapsibleWidget
    },

    emits: [],

    data() {
        return {
            selectedFilters: null
        };
    },

    computed: {
        options() {
            return this.rolesThatCanOnlyViewDeliverablesVisibleToRole.map(role => ({
                label: role.name,
                value: role._id
            }));
        },

        visibleToFilter: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.VisibleToFilter];
            },
            set(value) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateVisibleToFilter, value);
            }
        },

        rolesThatCanOnlyViewDeliverablesVisibleToRole() {
            return this.$store.getters[RolesGetter.getRolesThatDoNotHaveAction](
                this.$auth.Actions.CanChangeDeliverableVisibility
            );
        }
    },

    watch: {
        visibleToFilter: {
            immediate: true,
            handler(newValue) {
                if (!Array.isArray(newValue)) {
                    this.selectedFilters = newValue;
                }
            }
        }
    },

    methods: {
        setSelectedFilters(selectedFilters) {
            this.selectedFilters = selectedFilters;
            this.visibleToFilter = selectedFilters ? [selectedFilters] : [];
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-visible-to-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}
</style>
